import React from 'react';

import SystemMessage from './SystemMessage';

import { Link } from 'libs/router';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  influencerActions?: React.ReactNode,
  text: string,
  campaignId: number,
  subcampaignId: number,
  isBrand: boolean,
  offer?: number | null
};

class SystemChatMessageQuoteProvided extends SystemMessage<Props> {
  render() {
    const {
      influencerActions,
      text,
      campaignId,
      subcampaignId,
      isBrand
    } = this.props;

    const disclaimer = __t('system_message.quote_provided_disclaimer');
    const disclaimerTooltip = __t(`system_message.expiration_disclaimer_${isBrand ? 'brand' : 'creator'}_tooltip`);

    return (
      <React.Fragment>
        {this.renderIcon('brief-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {text}
            </div>
            <div className="messages-system-message__paragraph">
              <Link
                to={`/campaigns/${campaignId}/${isBrand ? 'subcampaigns' : 'details'}/${subcampaignId}`}
                className="messages-system-message__link"
              >
                {__t('system_message.view_the_brief')}
              </Link>
            </div>
            { this.renderDisclaimer(disclaimer, disclaimerTooltip) }
            { !isBrand && this.renderActions(influencerActions) }
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageQuoteProvided;
